import { Link } from 'react-router-dom';
import { stats, testimonials } from '@/mocks/homeData';

export default function CTASection() {
  return (
    <>
      <section className="py-16 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                  <i className={`${stat.icon} text-xl`}></i>
                </div>
                <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                  {stat.value}
                </div>
                <div className="text-foreground-600 text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="text-center mb-12 md:mb-16">
            <p className="text-primary-500 text-sm font-medium tracking-widest uppercase mb-3">
              Testimonials
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
              客户口碑
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              听听她们怎么说——每一位顾客的真实声音
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((t) => (
              <div
                key={t.name}
                className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-7"
              >
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed mb-5">
                  &ldquo;{t.content}&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-20 md:py-28 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20beauty%20and%20wellness%20background%2C%20soft%20warm%20lighting%2C%20elegant%20spa%20atmosphere%2C%20cream%20and%20rose%20gold%20tones%2C%20dreamy%20aesthetic%2C%20high%20end%20brand%20imagery&width=1600&height=600&seq=cta-bg-001&orientation=landscape"
          alt="比基尼护士 CTA 背景"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/45"></div>
        <div className="relative z-10 w-full px-4 md:px-6">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5">
              准备好发现不一样的自己了吗？
            </h2>
            <p className="text-white/75 text-base md:text-lg mb-8 max-w-lg mx-auto leading-relaxed">
              无论是写真拍摄、角色扮演服装还是美体护理，比基尼护士都为你准备好了一切
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category"
                className="px-8 py-3.5 bg-primary-500 text-white rounded-md text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即探索服务
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md text-base font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}